export enum LICENSECAP {
    MIN = 1,
    MAX = 20,
}

export enum NUMBERSCAP {
    MIN = 0,
    MAX = 20,
}
